module.exports = __webpack_public_path__ + "static/flags/AQ-f6590069e9af46f110adb1a51fe5fa91.gif";